
























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Alertas from '@/pantallas/TorreControl/ControlConfiguracion/Configuraciones/Alertas.vue';
import CustomDashboard from '@/pantallas/TorreControl/ControlConfiguracion/Configuraciones/CustomDashboard.vue';
import Tiempos from '@/pantallas/TorreControl/ControlConfiguracion/Configuraciones/Tiempos.vue';

@Component({
  name: 'PanelesConfiguracion',
  components: {
    Alertas,
  },
})
export default class PanelesConfiguracion extends Vue {
  panels: any[] = [
    {
      title: 'Alertas',
      component: Alertas,
      checkId: false,
    },
    {
      title: 'Personalización',
      component: CustomDashboard,
      checkId: false,
    },
    {
      title: 'Configuracion de Tiempos',
      component: Tiempos,
      checkId: false,
    },
  ];
  clientId: string = '';

  created() {
    this.clientId = localStorage.getItem('clienteDefecto');
  }

  showCheck(checkId: boolean) {
    if (checkId) {
      if (['2624'].includes(this.clientId)) return true;
      else return false;
    } else {
      return true;
    }
  }
}
